import { Box, makeStyles, Paper, useMediaQuery } from '@material-ui/core';
import ChatContextMenuContainer from '@src/components/ChatContextMenu';
import { appConfig } from '@src/config/appConfig';
import { RootState } from '@src/store/reduxstore';
import { useSelector } from 'react-redux';
import {
  CONTACT_SECTION_WIDTH,
  LAYOUT_PADDING_WIDTH,
  SIDE_MENU_WIDTH,
} from '../Layout/Utils';
import './index.css';

const HEADER_OFFSET = '194px';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    borderRadius: '8px',
    position: 'relative',
    zIndex: 1,
  },
  absoluteRight: {
    position: 'absolute',
    right: `${SIDE_MENU_WIDTH + LAYOUT_PADDING_WIDTH}px`,
    zIndex: 1000,
    margin: '0 0 10px',
  },
}));

const ContactSection: React.FC = () => {
  const { container, absoluteRight } = useStyles();

  const isMaxWidth = useMediaQuery(
    `(max-width:${appConfig.maxWidthConsole}px)`
  );

  const isContextMenuOpened = useSelector(
    (state: RootState) => state.agentConsole.chatContextMenu.isOpened
  );
  if (!isContextMenuOpened) return null;

  return (
    <Box
      className={container}
      width={isMaxWidth ? '100%' : CONTACT_SECTION_WIDTH}
      style={isMaxWidth ? { backgroundColor: 'transparent' } : undefined}
    >
      <Paper
        className={`ContextMenuSection ${isMaxWidth ? absoluteRight : ''}`}
        elevation={1}
        style={{
          height: isMaxWidth ? `calc(100vh - ${HEADER_OFFSET})` : '100%',
          width: `${CONTACT_SECTION_WIDTH}px`,
          borderRadius: '8px 0px 0px 8px',
          boxShadow: '-4px 1px 8px 0px #00000014',
        }}
      >
        <div className="ContextMenuContents">
          <ChatContextMenuContainer />
        </div>
      </Paper>
    </Box>
  );
};

export default ContactSection;
